export default __webpack_public_path__ + "static/media/toy5.e2b922d6.jpg";